<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/folder-image-plus.svg" size="2"></app-svg>
  <h1>Duplicate Gallery</h1>
  <p>This creates an exact copy but it won’t include collaborators and feedback.</p>

  <app-radio [checked]="alsoDuplicateAssets()" (click)="alsoDuplicateAssets.set(!alsoDuplicateAssets())">
    Also duplicate all assets.
  </app-radio>

  <button
    appButton
    name="confirm"
    location="duplicate-gallery-dialog"
    color="primary"
    data-test-id="duplicate-confirmation"
    (click)="confirm()"
    height="4"
    size="3"
    shape="round"
    weight="bold"
    spacing="full"
  >
    <span [class.hidden-text]="duplicating()">Duplicate</span>
    @if (duplicating()) {
      <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
    }
  </button>

  <button
    appButton
    name="cancel"
    location="duplicate-gallery-dialog"
    color="simple-gray"
    (click)="close(false)"
    size="3"
    height="1"
    shape="round"
    weight="bold"
    class="sub-cta"
    [center]="true"
  >
    Cancel
  </button>
</div>
